import * as React from 'react';

class GlobalErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        console.log('Error:');
        console.log(error);
        console.log('Info:');
        console.log(info);
    }

    render() {
        return this.props.children;
    }
}

export { GlobalErrorBoundary }


// WEBPACK FOOTER //
// ./src/common/error/GlobalErrorBoundary.js